import React, { useEffect, useState } from "react";
import Loader from "components/common/loader/Loader";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { downloadInvoicesData } from "services/bankServices";
import { getCurrentDate } from "utils/Utils";
const DownloadData = () => {
  const { t } = useTranslation();
  const [invalidToken, setInvalidToken] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { bankId } = useParams();
  const { userId } = useParams();
  const { token } = useParams();

  useEffect(() => {
    const downloadData = async () => {
      let response = await downloadInvoicesData(bankId,userId,token);
      if (response?.success) {
        const url = response?.payLoad;
        window.open(url, '_blank', 'noopener,noreferrer');
        setIsLoading(false)
      }
      //else if(response?.status == 403){
      else {
        setInvalidToken(true)
      }
    };
    downloadData();
  }, []);

  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center w-100"
        style={{ height: "100vh" }}
      >
        {invalidToken ? (
          <div className="d-flex justify-content-center align-items-center flex-column">
            <img src={"/assets/icons/expiredicon.png"} />
            <h4 className="fw-bold">{t("link-invalid-or-expired")}</h4>
          </div>
        ) : isLoading ? (
          <div className="text-center">
            <Loader />
            <h5 className="mt-4">{t("data-download-message")}</h5>
          </div>
        ):(
          <div className="text-center">
            <h5 className="mt-4">{t("data-download-success-message")}</h5>
          </div>
        )}
      </div>
    </>
  );
};

export default DownloadData;
